export default function () {
  return {
    customers: [],
    customerUserDetails: undefined,
    isLoadingCustomers: false,
  };
}
